import { render } from "./TransportDashboard.vue?vue&type=template&id=1defe1aa&scoped=true"
import script from "./TransportDashboard.vue?vue&type=script&lang=js"
export * from "./TransportDashboard.vue?vue&type=script&lang=js"

import "./TransportDashboard.vue?vue&type=style&index=0&id=1defe1aa&lang=css"
import "./TransportDashboard.vue?vue&type=style&index=1&id=1defe1aa&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1defe1aa"]])

export default __exports__